import React from "react";
import { useField } from "formik";
import {
  Typography,
  TextFieldProps,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { upperFirst } from "../../utils/upperFirst";

export type CustomCheckboxProps = {
  name: string;
  label: string | React.ReactNode;
  checked?: boolean;
};

const FormInputCheckbox: React.FC<CustomCheckboxProps & TextFieldProps> = (
  props,
) => {
  const { name, label } = props;
  const [field, meta] = useField(name);
  const { error, touched } = meta;
  const { t } = useTranslation();
  return (
    <FormGroup>
      <FormControlLabel
        label={
          <Typography
            variant="body1"
            component="p"
            data-testid={`label${upperFirst(name)}`}
          >
            {label}
          </Typography>
        }
        value="right"
        labelPlacement="end"
        control={
          <Checkbox
            {...field}
            id={name}
            checked={props.checked}
            data-testid={`checkbox${upperFirst(name)}`}
            inputProps={{
              "aria-label": t(`label.${name}`),
            }}
          />
        }
      />
      {!!touched && !!error && (
        <FormHelperText error={true}>
          <Typography
            style={{ marginLeft: 14, marginRight: 14 }}
            variant="body2"
            data-testid={`error${upperFirst(name)}`}
          >
            {error}
          </Typography>
        </FormHelperText>
      )}
    </FormGroup>
  );
};

export default FormInputCheckbox;
